module.exports = __webpack_public_path__ + "img/img_title2.b6a5fcc2.png";